export default {
    props: {
        create: { default: false },
        data: {
           default: function() {
                return { id: 0, name: '' };
            }
        },
        minLength: { default: 3 },
        name: { default: ''},
        errorName: { default: ''}
    },
    data () {
        return {
            disableEntry: false,
            myData: {},
            blankEntry: false,
            url: false,
            entMsg: false,
            hasError: false,
            label: false,
            id: 'typeahead-' + this.$root.uniqueid(),
            entity: { id: 0, name: '' },
            query: '',
            index: false,
            index_name: '', // This is the var you have to set
        }
    },
    created () {
        this.myData = this.data;
        this.setup();
    },
    methods: {
        error(data){
            console.log('Base Error');
            console.log(data);
            // DO SOMETHING
        },
        // This should be re-setup on the vue template
        entityName(item) {
            if (typeof item['name'] !== 'undefined') {
                return item.name;
            }
            return item;
        },

        setEntity(entity) {
            this.entity = entity;
            this.query = this.entity.name;
            this.$emit('input', this.entity);
        },

        createEntity() {
            if (this.disableEntry) return;
            this.disableEntry = true;
            $('#' + this.id).typeahead('close');
            if (!this.url) {
                alert('URL Not Setup for Entity Creation.');
                return;
            }
            this.axios.post(this.url, {
                name: this.query
            }).then((response) => {
                if (typeof response.data['public_id'] !== 'undefined' &&
                    response.data.public_id !== '') {
                    this.entMsg = 'created';
                    this.entity = {
                        created: true,
                        name: this.query,
                        id: response.data.public_id
                    };
                    this.$emit('input', this.entity);
                    this.blankEntry = false;
                    return;
                }
                this.entMsg = 'error';
            }).catch((response) => {
                if (typeof response.name !== 'undefined') {
                    this.entMsg = 'blank';
                    return;
                }
                this.entMsg = 'error';
            });
        },

        checkBlankEntry() {
            if (this.query == '') {
                this.entity.id = 0;
                this.entity.name = '';
            }
            this.blankEntry = (!this.entity.id && this.query !== '');
        },

        setup() {
            this.$eventHub.$on('emitErrors', this.error);
            if (this.create) {
                this.$eventHub.$on('createEntity' + this.id, this.createEntity);
            }
            this.$eventHub.$on('set' + this.name + this.index_name, this.setEntity);
            this.index = this.$root.client.initIndex(this.index_name + window.searchEnv);
            this.$nextTick(function () { // Runs after content is updated
                // Defaults
                let footer = false;
                let empty = [
                    '<li class="empty-message">',
                    'Unfortunately we could not find items that match the current query. Please try again.',
                    '</li>'
                ].join('\n');
                // If you can create a new entity?
                if (this.create === true) {
                    empty = footer = [
                        '<div class="tt-suggestion tt-selectable">',
                        '<a href="#" onclick="createEntity(\'' + this.id + '\')">',
                        '<i class="icon icon-circle-plus"></i> ',
                        'Create New</a>',
                        '</div>'
                    ].join('\n');
                }
                $('#' + this.id)
                    .typeahead({
                        minLength: this.minLength,
                        hint: !this.create,
                    }, {
                        source: this.index.ttAdapter(),
                        display: (item) => {
                            return this.entityName(item);
                        },
                        templates: {footer: footer, empty: empty}
                    })
                    .on('typeahead:select', (e, suggestion) => {
                        // console.log('typeahead:select');
                        this.setEntity({
                            id: suggestion.public_id,
                            name: this.entityName(suggestion)
                        });
                    })
                ;
                if (this.myData.id) {
                    this.setEntity(this.myData);
                    $('#' + this.id)
                        .typeahead('val', this.myData.name);
                }
            });
        },
    },
    // It's good to clean up event listeners before a component is destroyed.
    beforeDestroy () {
        this.$eventHub.$off('emitErrors', this.error);
        this.$eventHub.$off('set' + this.name + this.index_name, this.setEntity);
        if(this.create) {
            this.$eventHub.$off('createEntity' + this.id, this.createEntity);
        }
    }
}